import { startListeningToDbChanges } from 'serviceWorker/services/dbChangeListener';
import { channelServer, ChannelUnsubscribe } from 'shared/channels';
import { dbChangesContract } from 'shared/domain/dbChanges/dbChangesContract';

/** Answers the page's requests for notices of stored data changes. */
export function serveDbChangesRequests(): ChannelUnsubscribe {
  return channelServer.handle(dbChangesContract, { startListening: startListeningToDbChanges });
}
